
import { defineComponent } from 'vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { baseFileUrl } from '@/utils/constants';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
// import ProductSpecModal from './ProductSpecModal.vue';

export default defineComponent({
  name: 'ProductItem',
  components: {
    LeftOutlined,
    RightOutlined,
    PreviewImageModal
    // ProductSpecModal
  },
  data() {
    return {
      showPreviewModal: false,
      showSpecModal: false,
      showAddToCartModal: false
    };
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    getPreviewImgs() {
      const images: string[] = (this.vehicle.showImg || '')
        .split(',')
        .filter(s => s);

      return images.length > 0 ? images.map(i => `${baseFileUrl}${i}`) : [''];
    },
    getAttrImage() {
      return this.vehicle.attributeImg
        ? [`${baseFileUrl}${this.vehicle.attributeImg}`]
        : [''];
    },
    onImgClick() {
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showSpecModal = false;
      this.showPreviewModal = false;
    },
    handleSpecification() {
      this.showSpecModal = true;
    },
    handleInqury() {
      this.$router.push({
        name: 'ProductsInquiry',
        params: {
          id: this.vehicle.id,
          vehicleName: this.vehicle.vehicleName,
          vehicleType: this.vehicle.vehicleType,
          showImg: this.vehicle.showImg || '',
          modelNum: this.vehicle.modelNum
        }
      });
    }
  }
});
